import { ElementType } from './constants';
import elementEvents from './elementEvents';

export const upiPaymentMethodSelected = () => {
  const { elementClicked } = elementEvents({
    webElement: {
      elementType: ElementType.Button,
      name: 'upi-cta',
      text: 'upi-cta',
      htmlId: 'upi-click',
      location: 'checkout',
    },
  });

  elementClicked();
};
